const newlinesToLineBreak = (text: string) => {
  return text.replace(/(\r\n|\n|\r)/g, '<br>');
};

export default newlinesToLineBreak;
